import { licenceAccountsActions } from "./accounts/actions";
import { licenceActions } from "./licence/actions";
import { LicencingModulePluginStore } from "./plugin-store";

export const actions = {
  ...licenceAccountsActions,
  ...licenceActions,
  ...LicencingModulePluginStore.actions,
};
